import { format } from 'date-fns';
import { DATE_FORMATS } from '../../utils/date';

/**
 * epoch-ms → formatted label for the care-plan detail charts, which all plot a numeric time x-axis.
 * `formatChartAxisMonth` labels an axis tick ("Jun 2025"); `formatChartDate` labels a tooltip / point
 * ("Jun 3, 2025"). Both return '' for a NaN input so a bad value renders blank rather than the
 * date-fns "Invalid Date" string.
 */
export const formatChartAxisMonth = (value: number): string => {
  const date = new Date(value);
  return isNaN(date.getTime()) ? '' : format(date, DATE_FORMATS.MONTH_YEAR);
};

export const formatChartDate = (value: number): string => {
  const date = new Date(value);
  return isNaN(date.getTime()) ? '' : format(date, DATE_FORMATS.DATE);
};

/**
 * The `[min, max]` epoch-ms span of a chart's plotted points, or `undefined` when there's nothing to
 * span — no finite values, or every point falls on the same instant (a degenerate zero-width range
 * that can't be zoomed to). Feeds the charts' zoom-to-fit control.
 */
export const timeExtent = (values: number[]): [number, number] | undefined => {
  const finite = values.filter((v) => Number.isFinite(v));
  if (finite.length === 0) return undefined;
  const min = Math.min(...finite);
  const max = Math.max(...finite);
  return min < max ? [min, max] : undefined;
};
